<template>
  <div>
    <Loading :loading="loading" />
    <v-widget title="Nuevo Broker" padding-top="pt-0" fluid>
      <template #content>
        <v-stepper v-model="step" alt-labels flat class="elevation-0">
          <v-stepper-header elevation="0" class="elevation-0 p-0">
            <template v-for="(item, i) in steps">
              <v-stepper-step
                :key="`${i}-step`"
                :complete="step > i + 1"
                :step="i + 1"
              >
                <span class="primary--text text-center">{{ item.title }}</span>
              </v-stepper-step>
              <v-divider :key="i" v-if="i + 1 < steps.length" />
            </template>
          </v-stepper-header>
          <!-- COMPONENTS -->
          <v-stepper-items>
            <v-stepper-content
              v-for="(item, i) in steps"
              :key="`step-content-${i}`"
              :step="i + 1"
              class="mt-0 pa-0"
            >
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <component
                  :is="item.component"
                  v-bind="{
                    broker
                  }"
                  :canPrevious="step > 1"
                  :canNext="step < steps.length"
                  :canSubmit="step === steps.length"
                  @next="handleSubmit(handleNext)"
                  @previous="handlePrevious"
                  @submit="handleSubmit(handleFormSubmit)"
                  @cancel="handleCancel"
                />
              </ValidationObserver>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </v-widget>
  </div>
</template>

<script>
import Loading from '@/components/commons/Loading.vue'
import VWidget from '@/components/commons/VWidget'
import BrokerService from '@/services/broker'
import General from './wizard/General.vue'
import Smtp from './wizard/Smtp.vue'
import Media from './wizard/Media.vue'

export default {
  components: { VWidget, Loading, General, Smtp, Media },
  data() {
    return {
      steps: [
        {
          title: 'General',
          component: 'General'
        },
        {
          title: 'Media',
          component: 'Media'
        },
        {
          title: 'SMTP',
          component: 'Smtp'
        }
      ],
      step: 1,
      loading: false,
      broker: {
        color: '#00559E',
        files: [],
        smtp: {
          host: '',
          port: '',
          username: '',
          password: '',
          encryption: ''
        }
      },
    }
  },
  computed: {
    canPrevious() {
      return this.step > 1
    }
  },
  async created() {
    this.loading = true
    try {
      const id = this.$route.params.id
      if (id) {
        const data = await BrokerService.find(id, {
          include: 'smtp'
        })
        this.broker = { ...data, files: [] }
      }
    } catch (error) {
      console.log(error)
      this.$dialog.message.error('No se pudo cargar el registro.')
    } finally {
      this.loading = false
    }
  },
  methods: {
    handleCancel() {
      this.$router.push({ name: 'Brokers' })
    },
    handleNext() {
      this.step = this.step + 1
    },
    handlePrevious() {
      this.step = this.step - 1
    },
    async handleFormSubmit() {
      this.loading = true
      try {
        if (this.broker.smtp.password == '') delete this.broker.smtp.password
        await BrokerService.save(this.broker)
        this.$dialog.notify.success('Registro guardado con éxito.')
        this.$router.go(-1)
      } catch (error) {
        console.log(error)
        this.$dialog.message.error('No se pudo guardar el registro.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 960px) {
  .v-stepper--alt-labels .v-stepper__header {
    height: 110px !important;
  }
}
</style>
